<template>
    <div class="memberInfo" v-track:click :track-params="JSON.stringify({event: 112})">
        <HeadTime title="预售专区" @onMore='onMore' :presellData='presellData' />
        <div class="commodityLess" v-if="presellData.presaleSkuList.length < 3" @click="onMore">
            <div v-for="(item, index) in presellData.presaleSkuList" :key="index" class="item" :class="{'itemOpacity': item.inventoryRemainNum <= 0}" v-show="!index">
                <div class="img">
                    <img :src="$viewImageNew(item.imgUrl, 400,400)" alt="">
                </div>
                <div class="content">
                    <div class="name f28 col000">{{ item.skuShowName }}</div>
                    <div class="single" v-show="item.sellingPoint">{{ item.sellingPoint }}</div>
                    <div class="fot">
                        <div class="saleP"><i class="icon"></i><i>￥</i>????</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="commodity" @click="onMore" v-else>
            <div v-for="(item, index) in presellData.presaleSkuList" :key="index" class="item" :class="{'itemOpacity': item.inventoryRemainNum <= 0}" v-show="index < 3">
                <div class="pic picMoney">
                    <img :src="$viewImageNew(item.imgUrl, 400,400)" alt="商品图片">
                </div>
                <div class="character">
                    <div class="name">{{item.skuShowName}}</div>
                    <div class="fot">
                        <div class="saleP"><i class="icon"></i><i>￥</i>????</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import HeadTime from './comTemplate/headTime'
export default {
    components: {
        HeadTime
    },
    props: {
        presellData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        type: {
            type: String,
            default: ''
        }
    },
    methods: {
        onCountDown () {
            this.$emit('seckillCountDown')
        },
        onMore () {
            this.$emit('presellClick')
        }
    }
}
</script>
<style lang="scss" scoped>
.memberInfo {
    padding: 18px 24px;
}
.commodity {
    padding-top: 24px;
    overflow-x: overlay;
    white-space: nowrap;
    display: flex;
    justify-content: space-around;
    .itemOpacity {
        opacity: 0.5;
    }
    .item {
        display: flex;
        justify-content: flex-start;
        flex: 0 0 230px;
        display: inline-block;
        padding-top: 18px;
        &:nth-child(-n + 3) {
            padding-top: 0;
        }
        .pic {
            position: relative;
            flex: 0 0 230px;
            height: 230px;
            background-color: #f5f5f5;
            display: flex;
            img {
                align-self: center;
                justify-self: center;
                border-radius: 2px;
                display: inline-block;
                margin: 0 auto;
                background: #f2f3f5;
                object-fit: cover;
            }
        }
        box-sizing: border-box;
        .character {
            position: relative;
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            align-content: space-between;
            box-sizing: border-box;
            .name {
                text-align: left;
                font-size: 24px;
                line-height: 36px;
                padding-right: 14px;
                height: 36px;
                width: 100%;
                color: #333333;
                font-weight: 400;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                white-space: normal;
                word-break: break-all;
                margin-bottom: 8px;
                margin-top: 18px;
            }
            .saleOut {
                margin: 0 auto;
                font-size: 20px;
                color: #999999;
                transform: scale(0.8);
                transform-origin: left bottom;
            }
            .fot {
                font-weight: bold;
            }
            .saleP {
                width: 100%;
                height: 32px;
                font-size: 32px;
                line-height: 32px;
                margin-bottom: 4px;
                font-weight: bold;
                color: #ff571f;
                font-family: Helvetica;
                i {
                    display: inline-block;
                    font-size: 24px;
                    transform: scale(0.92);
                    transform-origin: left -130%;
                    &.icon {
                        width: 28px;
                        height: 28px;
                        transform: scale(1);
                        background: url("../../../../assets/img/b2b/time3.png")
                            no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
            .originP {
                height: 28px;
                line-height: 28px;
                font-size: 24px;
                text-decoration: line-through;
                transform: scale(0.83);
                transform-origin: left 80%;
                color: #999999;
                &.ml8 {
                    margin-left: 8px;
                }
            }
        }
        &.mr20 {
            margin-right: 20px;
        }
    }
}
.commodityLess {
    padding-top: 24px;
    .item {
        position: relative;
        display: flex;
        justify-content: flex-start;
        width: 100%;
        padding-top: 18px;
        &:nth-child(-n + 3) {
            padding-top: 0;
        }
        .img {
            flex: 0 0 230px;
            font-size: 0;
            height: 230px;
            background-color: #fafafa;
            display: flex;
            img {
                border-radius: 4px;
                display: inline-block;
                margin: 0 auto;
                align-self: center;
                justify-self: center;
                background: #f2f3f5;
                object-fit: cover;
            }
        }
        .content {
            margin: 0;
            padding: 4px 4px 8px 24px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .name {
                font-size: 28px;
                line-height: 40px;
                color: #333333;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                white-space: normal;
                word-break: break-all;
            }
            .single {
                font-size: 24px;
                color: #999999;
            }
            .saleOut {
                font-size: 20px;
                color: #999999;
                transform: scale(0.8);
                transform-origin: left bottom;
            }
            .fot {
                font-weight: bold;
                .saleP {
                    width: 100%;
                    height: 32px;
                    font-size: 32px;
                    line-height: 32px;
                    margin-bottom: 6px;
                    color: #ff571f;
                    font-family: Helvetica;
                    i {
                        display: inline-block;
                        font-size: 24px;
                        transform: scale(0.92);
                        transform-origin: left -130%;
                        &.icon {
                            width: 28px;
                            height: 28px;
                            transform: scale(1);
                            background: url("../../../../assets/img/b2b/time3.png")
                                no-repeat;
                            background-size: 100% 100%;
                        }
                    }
                }
                .originP {
                    height: 28px;
                    line-height: 28px;
                    font-size: 24px;
                    text-decoration: line-through;
                    transform: scale(0.83);
                    transform-origin: left 80%;
                    color: #999999;
                    &.ml8 {
                        margin-left: 8px;
                    }
                }
            }
        }
    }
}
/deep/ .count span {
    font-size: 24px;
}
/deep/ .count .time {
    align-items: center;
}
/deep/ .van-tabs__line {
    bottom: 0;
}
</style>
